<script setup>
import Logo from "../../../img/logo/logo-white.png";
import {envs} from "@/main/envs";
import BtnDownload from "@/components/buttons/BtnDownload.vue";
import BtnTrial from "@/components/buttons/BtnTrial.vue";

const productName = envs.productName;
</script>
<template>
  <header class="page-header nav">
    <div class="wrap nav-inner">
      <div class="flex logo-container">
        <router-link class="brand" to="/">
          <div class="logo" aria-hidden="true">
            <img :src="Logo" :alt="productName"/>
          </div>
          <div>{{ productName }} <span>· <i>hyper</i>Reading</span></div>
        </router-link>
      </div>
      <div class="flex">
        <el-menu mode="horizontal">
          <el-menu-item>
            <router-link to="/features" exact-active-class="active">
              核心功能
            </router-link>
          </el-menu-item>
          <el-menu-item>
            <router-link to="/pricing" exact-active-class="active">
              版本与定价
            </router-link>
          </el-menu-item>
          <el-menu-item>
            <router-link to="/faq" exact-active-class="active">
              FAQ
            </router-link>
          </el-menu-item>
          <el-menu-item>
            <router-link to="/partners" exact-active-class="active">
              代理合作
            </router-link>
          </el-menu-item>
          <el-menu-item>
            <router-link to="/tech-coop" exact-active-class="active">
              技术合作
            </router-link>
          </el-menu-item>
          <el-menu-item>
            <router-link to="/company" exact-active-class="active">
              关于我们
            </router-link>
          </el-menu-item>
        </el-menu>
      </div>
      <div class="flex">
        <div class="btn-group">
          <btn-download/>
          <btn-trial class="primary"/>
        </div>
      </div>
    </div>
  </header>
</template>

<style lang="scss" scoped>
.page-header {
  padding: 0;
  display: flex;
  .nav-inner {
    justify-content: space-between;
    width: 1024px;
  }
}
.el-menu {
  background: transparent;
  &.el-menu--horizontal {
    border-bottom: none;
    display: flex;
    gap: 4px;

    > .el-menu-item {
      padding: 0;

      a {
        text-decoration: none;
        padding: 8px 10px;
        border-radius: 10px;
        transition: .2s ease;

        &.active {
          background: rgba(255,255,255,.06);
          color: var(--text);
        }
      }
      &:hover {
        background: none;
        color: var(--text);
        a {
          background: rgba(255,255,255,.06);
        }
      }
    }
  }
  > .el-menu-item {
    padding: 0;

    a {
      text-decoration: none;
      padding: 8px 10px;
      border-radius: 10px;
      transition: .2s ease;
    }
    &:hover {
      background: none;
      color: var(--text);
      a {
        background: rgba(255,255,255,.06);
      }
    }
  }
}
.logo {
  background: none;
  box-shadow: none;
  display: flex;
  justify-content: center;
  align-items: center;
  img {
    max-width: 100%;
    max-height: 100%;
    object-fit: fill;
  }
}
</style>
